import { debounce, getProjectId } from '../helpers/helpers';
import { isLocalStorageAvailable } from '../helpers/mini/isStorageAvailable';
import { uiState } from '../state';
import { broadcastReloadIframeToIframes } from './helpers/adjustIFrameSize';

var resizeInProcess = false;
var dndInitMousePos = [0, 0];
var chatHeight, chatWidth, typeBorderHor, typeBorderVert;
var chatInitLeftPos, chatInitRightPos, chatInitTopPos, chatInitBottomPos;
var chatTopPosBeforeResize;
var chatBottomPosBeforeResize;
var chatRightAligned,
    chatLeftAligned,
    chatTopAligned,
    chatBottomAligned;


export function getBorderType(posInfo, chatHolderDiv) {
    if (Math.abs(chatHolderDiv.getBoundingClientRect().bottom - posInfo.clientY) < 10) {
        typeBorderHor = 'bottom';
    } else if (Math.abs(chatHolderDiv.getBoundingClientRect().top - posInfo.clientY) < 10) {
        typeBorderHor = 'top';
    } else {
        typeBorderHor = 'none';
    }

    if (Math.abs(chatHolderDiv.getBoundingClientRect().left - posInfo.clientX) < 10) {
        typeBorderVert = 'left';
    } else if (Math.abs(chatHolderDiv.getBoundingClientRect().right - posInfo.clientX) < 10) {
        typeBorderVert = 'right';
    } else {
        typeBorderVert = 'none';
    }

    return { typeBorderHor, typeBorderVert };
}

export function isMouseInHeader(posInfo, chatHolderDiv) {
    if (
        chatHolderDiv.getBoundingClientRect().top < posInfo.clientY && (posInfo.clientY < chatHolderDiv.getBoundingClientRect().top + 60) &&
        chatHolderDiv.getBoundingClientRect().left < posInfo.clientX && posInfo.clientX < chatHolderDiv.getBoundingClientRect().right) {
        return true;
    }

    return false;
}


export function onMouseHoverForResizeTextChat(e) {
    const chatHolderDiv = e.currentTarget;

    if (resizeInProcess) return;
    if (uiState.textChat.expanded) return;
    if (uiState.textChat.inlined) return;

    var posInfo = e.touches ? e.touches[0] : e;

    if (isMouseInHeader(posInfo, chatHolderDiv)) {
        chatHolderDiv.classList.add('with-hover');
    } else {
        chatHolderDiv.classList.remove('with-hover');
    }

    typeBorderHor = getBorderType(posInfo, chatHolderDiv).typeBorderHor;
    typeBorderVert = getBorderType(posInfo, chatHolderDiv).typeBorderVert;

    chatHolderDiv.classList.remove('none-none');
    chatHolderDiv.classList.remove('with-cursors');

    chatHolderDiv.classList.remove('top-left');
    chatHolderDiv.classList.remove('top-right');
    chatHolderDiv.classList.remove('bottom-left');
    chatHolderDiv.classList.remove('bottom-right');
    chatHolderDiv.classList.remove('none-left');
    chatHolderDiv.classList.remove('none-right');
    chatHolderDiv.classList.remove('top-none');
    chatHolderDiv.classList.remove('bottom-none');

    chatHolderDiv.classList.add(typeBorderHor + '-' + typeBorderVert);
    if (typeBorderHor !== 'none' || typeBorderVert !== 'none') {
        chatHolderDiv.classList.add('with-cursors');
    }
}

export function onMouseDownForResizeTextChat(e) {
    const chatHolderDiv = e.currentTarget;
    if (uiState.textChat.expanded) {
        return;
    }
    if (uiState.textChat.inlined) {
        return;
    }

    resizeInProcess = true;

    var posInfo = e.touches ? e.touches[0] : e;
    dndInitMousePos = [
        posInfo.clientX,
        posInfo.clientY
    ];

    var chatRect = chatHolderDiv.getBoundingClientRect();

    chatHeight = chatRect.height;
    chatWidth = chatRect.width;

    typeBorderHor = getBorderType(posInfo, chatHolderDiv).typeBorderHor;
    typeBorderVert = getBorderType(posInfo, chatHolderDiv).typeBorderVert;

    chatInitLeftPos = parseInt(chatHolderDiv.style.left);
    chatInitRightPos = parseInt(chatHolderDiv.style.right);
    chatInitTopPos = parseInt(chatHolderDiv.style.top);
    chatInitBottomPos = parseInt(chatHolderDiv.style.bottom);

    chatTopPosBeforeResize = chatRect.top;
    chatBottomPosBeforeResize = chatRect.bottom;

    chatRightAligned = chatHolderDiv.style.right;
    chatLeftAligned = chatHolderDiv.style.left;
    chatTopAligned = chatHolderDiv.style.top;
    chatBottomAligned = chatHolderDiv.style.bottom;
}
export function onMouseUpForResizeTextChat() {
    if(resizeInProcess){
        broadcastReloadIframeToIframes();
    }
    resizeInProcess = false;
}
export function onMouseMoveForResizeTextChat(e) {
    if (!resizeInProcess) return;

    var posInfo = e.touches ? e.touches[0] : e;

    if (posInfo.clientX >= 0 && posInfo.clientY >= 0 && posInfo.clientX <= window.innerWidth && posInfo.clientY <= window.innerHeight) {
        resizeTextChat(posInfo);
    } else {
        resizeInProcess = false;
    }
}

export function resizeTextChat(posInfo) {
    var tempDeltaX = posInfo.clientX - dndInitMousePos[0];
    var tempDeltaY = posInfo.clientY - dndInitMousePos[1];

    if (typeBorderHor === 'bottom') {
        if (canResizeByHeight(typeBorderHor, tempDeltaY)) {
            setChatHeight(chatHeight + tempDeltaY);
            changeBottomPosIfNeeded(tempDeltaY);
        }

    } else if (typeBorderHor === 'top') {
        if (canResizeByHeight(typeBorderHor, tempDeltaY)) {
            setChatHeight(chatHeight - tempDeltaY);
            changeTopPosIfNeeded(tempDeltaY);
        }
    }

    if (typeBorderVert === 'right') {
        if (canResizeByWidth(typeBorderVert, tempDeltaX)) {
            setChatWidth(chatWidth + tempDeltaX);
            changeRightPosIfNeeded(tempDeltaX);
        }

    } else if (typeBorderVert === 'left') {
        if (canResizeByWidth(typeBorderVert, tempDeltaX)) {
            setChatWidth(chatWidth - tempDeltaX);
            changeLeftPosIfNeeded(tempDeltaX);
        }
    }
}

export function canResizeByHeight(borderType: string, delta: number) {
    const minChatHeight = uiState.textChat.options?.popup?.minHeight || uiState.textChat.defaults.minChatWidth;

    const expanding = (borderType === 'bottom' && delta > 0) || (borderType === 'top' && delta < 0);
    const h = borderType === 'bottom' ? (chatHeight + delta) : (chatHeight - delta);

    const newBottomtPos = chatBottomPosBeforeResize - delta;
    const newTopPos = chatTopPosBeforeResize + delta;

    if (borderType === 'bottom' && newBottomtPos <= 0 && h >= chatHeight) {
        return false;
    }
    if (borderType === 'top' && newTopPos <= 0 && h >= chatHeight) {
        return false;
    }

    return expanding ? (h >= minChatHeight) : (h > minChatHeight);
}

export function canResizeByWidth(borderType: string, delta: number) {
    const minChatWidth = uiState.textChat.options?.popup?.minWidth || uiState.textChat.defaults.minChatWidth;

    const expanding = (borderType === 'right' && delta > 0) || (borderType === 'left' && delta < 0);
    const w = borderType === 'right' ? (chatWidth + delta) : (chatWidth - delta);

    const newRightPos = chatInitRightPos - delta;
    const newLeftPos = chatInitLeftPos + delta;

    // console.info(delta, newRightPos, borderType, w, minChatWidth, tempDeltaX, delta);

    if (borderType === 'right' && newRightPos <= 0 && w >= chatWidth) {
        return false;
    }
    if (borderType === 'left' && newLeftPos <= 0 && w >= chatWidth) {
        return false;
    }

    return expanding ? (w >= minChatWidth) : (w > minChatWidth);
}

export function setChatHeight(h) {
    const chatHolderDiv = document.getElementById('alan-btn-chat-holder');
    if (!chatHolderDiv) return;
    chatHolderDiv.style.height = h + 'px';
    saveTextChatSizeAfterResize('height', h);
}
export function setChatWidth(w) {
    const chatHolderDiv = document.getElementById('alan-btn-chat-holder');
    if (!chatHolderDiv) return;
    chatHolderDiv.style.width = w + 'px';

    if (w < 300) {
        chatHolderDiv.classList.add('alan-chat-small');
    } else {
        chatHolderDiv.classList.remove('alan-chat-small');
    }

    saveTextChatSizeAfterResize('width', w);
}

export function changeBottomPosIfNeeded(delta) {
    if (chatBottomAligned) {
        saveTextChatPositionAfterResize('bottom', chatInitBottomPos - delta);
    }
}
export function changeTopPosIfNeeded(delta) {
    if (chatTopAligned) {
        saveTextChatPositionAfterResize('top', chatInitTopPos + delta);
    }
}

export function changeRightPosIfNeeded(delta) {
    if (chatRightAligned) {
        saveTextChatPositionAfterResize('right', chatInitRightPos - delta);
    }
}
export function changeLeftPosIfNeeded(delta) {
    if (chatLeftAligned) {
        saveTextChatPositionAfterResize('left', chatInitLeftPos + delta);
    }
}

export function getKeyForSavingTextChatPositionAfterResize(prop) {
    return `alan-btn-text-chat-pos-${prop}-${getProjectId()}`;
}

export function saveTextChatPositionAfterResize(prop, val) {
    if (val < 0) return;

    const chatHolderDiv = document.getElementById('alan-btn-chat-holder');

    chatHolderDiv.style[prop] = val + 'px';

    if (isLocalStorageAvailable) {
        localStorage.setItem(getKeyForSavingTextChatPositionAfterResize(prop), val);
    }
}

export function getTextChatSizeAfterResize(prop) {
    if (isLocalStorageAvailable) {
        return localStorage.getItem(getKeyForSavingTextChatPositionAfterResize(prop));
    }
    return null;
}

export function saveTextChatSizeAfterResize(prop, val) {
    if (isLocalStorageAvailable) {
        localStorage.setItem(getKeyForSavingTextChatPositionAfterResize(prop), val);
    }
}

export function getTextChatPositionAfterResize(prop) {
    if (isLocalStorageAvailable) {
        return localStorage.getItem(getKeyForSavingTextChatPositionAfterResize(prop));
    }
    return null;
}

export function fixTextChatSizeIfNeeded(width, height) {
    if (height !== null && window.innerHeight < height) {
        setChatHeight(window.innerHeight);
    }
    if (width !== null && window.innerWidth < width) {
        setChatWidth(window.innerWidth);
    }
}